














import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { Grid, GridItem } from 'vant'
import { getSelectedCityId, isHzwApp } from '@utils/index'

@Component({
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  }
})
export default class GridSection extends Vue {
  @Prop({
    default: () => []
  })
  readonly chanels!: any[]

  itemClick(index: number) {
    if (index < this.grids.length) {
      const item = this.grids[index]
      this.$emit('channelClick', item)
      if (item.channelType == '1') {
        // 频道类型(1：组件频道，2：跳转链接)
        if (isHzwApp()) {
          location.href = `https://life.cekid.com/h5/channel/${item.channelId}?channelId=${item.channelId}`
        } else {
          this.$router.push({ name: 'channel', params: { channelId: item.channelId } })
        }
      } else {
        if (item.linkUrl) {
          if (item.linkUrl.indexOf('life.cekid.com/y/home') > -1) {
            //月嫂频道
            item.linkUrl = item.linkUrl + (item.linkUrl.indexOf('?') !== -1 ? '&' : '?') + `citycode=${getSelectedCityId()}`
          } else if (item.linkUrl.indexOf('life.cekid.com/h5/category') > -1) {
            item.linkUrl = item.linkUrl + (item.linkUrl.indexOf('?') !== -1 ? '&' : '?') + 'swt=1'
          }
          location.href = item.linkUrl
        }
      }
    }
  }

  handleScroll(e: any) {
    if (this.isScroll) {
      const actline = this.$refs.line_active_ref as HTMLElement
      const item = document.querySelector('.grid-item') as HTMLElement

      const left = e.target.scrollLeft
      const range = item.getBoundingClientRect().width * (this.grids.length - 5)
      actline.style.transform = `translateX(${(100 * left) / range}%`
    }
  }

  /*
icon支持展示1行或2行，每行最多显示5个图标，不同icon数量显示规则如下：
● 小于6个时：一行居中对齐
● 小于9个时：一行滚动，
● 等于9、10个时：显示为2行，每行5列  第二行左对齐
● 大于10个时：只显示排序前10  两行五列
*/

  get grids() {
    if (this.chanels.length > 10) {
      //大于10个时：只显示排序前10
      return this.chanels.slice(0, 10)
    }
    return this.chanels
  }

  get isScroll() {
    return this.grids.length > 5 && this.grids.length < 9
  }

  get lineNum() {
    if (this.grids.length < 9) {
      return 1
    }
    return 2
  }

  get itemWidth() {
    let num = 5
    if (this.grids.length < 6) {
      num = this.grids.length
    }
    return 100 / num + '%'
  }
}
